<nav class="secondary-nav">
  <a href="https://app.ubilaw.com" target="_blank">Connexion</a>
  <a routerLink="/mentions-legales">Mentions légales</a>
  <a routerLink="/politique-de-confidentialite">Politique de confidentialité</a>
</nav>
